import placeholderMixin from "@/mixins/forms/placeholder";

export default {
  mixins: [placeholderMixin],
  props: {
    value: {
      type: [String, Number],
      required: false,
      default: "",
    },
    autocomplete: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    computedLabel() {
      return this.label || this.placeholder;
    },
  },
};
